import domain from '@framework/config/domain';
import dataroomConfig from '@dataroom/config';
import IconAccount from '@creditflowresearch/uilib/Icon/IconAccount';
import IconBank from '@creditflowresearch/uilib/Icon/IconBank';
import IconBondManager from '@creditflowresearch/uilib/Icon/IconBondManager';
import IconCalendar from '@creditflowresearch/uilib/Icon/IconCalendar';
import IconCapedge from '@creditflowresearch/uilib/Icon/IconCapedge';
import IconCard from '@creditflowresearch/uilib/Icon/IconCard';
import IconCrypto from '@creditflowresearch/uilib/Icon/IconCrypto';
import IconDescription from '@creditflowresearch/uilib/Icon/IconDescription';
import IconDocument from '@creditflowresearch/uilib/Icon/IconDocument';
import IconEarningsCalendar from '@creditflowresearch/uilib/Icon/IconEarningsCalendar';
import IconEnumeratedList from '@creditflowresearch/uilib/Icon/IconEnumeratedList';
import IconFilters from '@creditflowresearch/uilib/Icon/IconFilters';
import IconFolderOpen from '@creditflowresearch/uilib/Icon/IconFolderOpen';
import IconInvestorSet from '@creditflowresearch/uilib/Icon/IconInvestorSet';
import IconLayersGroup from '@creditflowresearch/uilib/Icon/IconLayersGroup';
import IconMappings from '@creditflowresearch/uilib/Icon/IconMappings';
import IconReddit from '@creditflowresearch/uilib/Icon/IconReddit';
import IconResearchDocument from '@creditflowresearch/uilib/Icon/IconResearchDocument';
import IconTrace from '@creditflowresearch/uilib/Icon/IconTrace';
import IconTable from '@creditflowresearch/uilib/Icon/IconTable';
import IconUnarchive from '@creditflowresearch/uilib/Icon/IconUnarchive';
import IconUserAnalytics from '@creditflowresearch/uilib/Icon/IconUserAnalytics';
import IconStockChart from '@creditflowresearch/uilib/Icon/IconStockChart';
import { IconComponentType } from '@creditflowresearch/uilib/Icon';
import {
  MARKET_OVERVIEW_ALL,
  MARKET_OVERVIEW_IGC,
  MARKET_OVERVIEW_HYC,
  MARKET_OVERVIEW_CONSUMER,
  LOAN_LEVEL_DATA,
  BWICS,
  CREDIT_FLOW_ARTICLES,
  TRACE,
  NEW_ISSUER_PIPELINE,
  OPEN_MARKET,
  PORTFOLIO_MONITOR,
  RESEARCH,
  NEW_ISSUE_STATS,
  BOND_SCREENER,
  CORPORATE_BOND_SCREENER,
  LEAGUE_TABLE,
  INVESTOR_SET,
  CAPEDGE_HOME,
  CALENDAR,
  COURT,
  EARNINGS_CALENDAR,
  INSIDER,
  SPLITS,
  EARNINGS,
  INDUSTRIAL,
  CRYPTO,
  ISSUE_REGISTRATION,
  REDDIT,
  ACTIVE_CALENDAR,
  CFX_INDICES,
  CFX_CORPORATE_INDICES,
  IG_ACTIVE_CALENDAR,
  IG_PIPELINE,
  HYC_ACTIVE_CALENDAR,
  HYC_PIPELINE,
} from './constants';

export interface IToolConfig {
  icons: Record<string, IconComponentType>,
  externalHosts: Record<string, string>,
  marketOverviewToolIds: readonly string[],
  defaultIcon: IconComponentType,
  domainProtocol: string,
}

export const TOOL_CONFIG: IToolConfig = {
  icons: {
    [MARKET_OVERVIEW_ALL]: null,
    [MARKET_OVERVIEW_IGC]: null,
    [MARKET_OVERVIEW_HYC]: null,
    [MARKET_OVERVIEW_CONSUMER]: null,
    [LOAN_LEVEL_DATA]: IconLayersGroup,
    [BWICS]: IconBondManager,
    [CREDIT_FLOW_ARTICLES]: IconDescription,
    [TRACE]: IconTrace,
    [NEW_ISSUER_PIPELINE]: IconCard,
    [OPEN_MARKET]: IconAccount,
    [PORTFOLIO_MONITOR]: IconFolderOpen,
    [RESEARCH]: IconResearchDocument,
    [NEW_ISSUE_STATS]: IconTable,
    [BOND_SCREENER]: IconFilters,
    [CORPORATE_BOND_SCREENER]: IconFilters,
    [LEAGUE_TABLE]: IconEnumeratedList,
    [INVESTOR_SET]: IconInvestorSet,
    [CAPEDGE_HOME]: IconCapedge,
    [CALENDAR]: IconCalendar,
    [COURT]: IconBank,
    [EARNINGS_CALENDAR]: IconEarningsCalendar,
    [INSIDER]: IconUserAnalytics,
    [SPLITS]: IconMappings,
    [EARNINGS]: IconDocument,
    [INDUSTRIAL]: IconAccount,
    [CRYPTO]: IconCrypto,
    [ISSUE_REGISTRATION]: IconUnarchive,
    [REDDIT]: IconReddit,
    [ACTIVE_CALENDAR]: IconCalendar,
    [CFX_INDICES]: IconStockChart,
    [CFX_CORPORATE_INDICES]: IconStockChart,
    [IG_ACTIVE_CALENDAR]: IconCalendar,
    [IG_PIPELINE]: IconCard,
    [HYC_ACTIVE_CALENDAR]: IconCalendar,
    [HYC_PIPELINE]: IconCard,
  },

  externalHosts: {
    [INVESTOR_SET]: dataroomConfig.investorset.hostname,
  },

  marketOverviewToolIds: [
    MARKET_OVERVIEW_ALL,
    MARKET_OVERVIEW_IGC,
    MARKET_OVERVIEW_HYC,
    MARKET_OVERVIEW_CONSUMER,
  ] as const,

  defaultIcon: IconFilters,
  domainProtocol: domain.protocol,
} as const;
